import { EnvConfig } from "./envconfig";

export const environment: EnvConfig = {
  production: false,
  sbdBaseUrl: 'http://localhost',
  apiBaseUrl: 'https://account-portal-api-local.suretybondsdirect.com',
  dougV2BaseUrl: 'http://localhost',
  apiLocalUrl: 'https://account-portal-api-local.suretybondsdirect.com/v4',
  titleBase: '(DEV) Account Portal',
  shouldCathyBeChatty: true,
  reCaptchaSiteKey: '6Lf1vxYqAAAAABdGAN_tEUhdlYlLwAWKUpREW84x',
  apiPrefix: 'v4'
};
